/**
 * NewEra layout — designed for 1920×1080 (Full HD) as the primary desktop canvas.
 *
 * Content lane with drawer open at FHD:
 *   1920 − 280 (drawer) − 48 (padding) = 1592px → PAGE_MAX_WIDTH caps at 1600.
 */

export const VIEWPORT_WIDTH = 1920;
export const VIEWPORT_HEIGHT = 1080;

export const DRAWER_WIDTH = 280;
export const APP_BAR_HEIGHT = 64;

/** Drawer switches to compact layout when viewport height is at or below this (1080p + browser chrome). */
export const DRAWER_COMPACT_MAX_HEIGHT = 960;

/** Horizontal padding inside the main content shell (each side). */
export const CONTENT_PADDING_X = 24;

/** Standard max width for most pages on FHD. */
export const PAGE_MAX_WIDTH = 1600;

/** Wide admin pages (tables, user admin). */
export const PAGE_MAX_WIDTH_WIDE = 1640;

/** @param {boolean} drawerOpen */
export const getPageMaxWidthCss = (drawerOpen = true) =>
  drawerOpen
    ? `min(${PAGE_MAX_WIDTH}px, calc(100vw - ${DRAWER_WIDTH + CONTENT_PADDING_X * 2}px))`
    : `min(${PAGE_MAX_WIDTH}px, calc(100vw - ${CONTENT_PADDING_X * 2}px))`;

/** Reusable page root sx — spread into the outer Box of each page. */
export const pageContainerSx = {
  maxWidth: PAGE_MAX_WIDTH,
  width: "100%",
  mx: "auto",
  boxSizing: "border-box",
};

export const pageContainerWideSx = {
  maxWidth: PAGE_MAX_WIDTH_WIDE,
  width: "100%",
  mx: "auto",
  boxSizing: "border-box",
};

/** Fullscreen kiosk shell — no app bar / drawer offset. */
export const kioskMainShellSx = {
  marginLeft: 0,
  marginTop: 0,
  px: 0,
  pb: 0,
  minHeight: "100dvh",
  width: "100%",
  maxWidth: "100vw",
  boxSizing: "border-box",
  overflow: "hidden",
};

/** Main content shell sx (Home.page.js). */
export const mainContentShellSx = (drawerOpen, isMobile) => ({
  marginLeft: !isMobile && drawerOpen ? `${DRAWER_WIDTH}px` : 0,
  marginTop: `${APP_BAR_HEIGHT}px`,
  px: { xs: 1.5, sm: `${CONTENT_PADDING_X}px` },
  pb: 4,
  minHeight: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  width: !isMobile && drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : "100%",
  maxWidth: "100vw",
  boxSizing: "border-box",
  transition: "margin-left 0.3s ease, width 0.3s ease",
});
